<template lang="pug">
.content-center
  .bets-wrap
    ul.nav.d-flex.justify-content-around(role='tablist')
      li.nav-item.flex-grow-1
        a#tab-normal.active(
          data-toggle='tab'
          href='#normal'
          role='tab'
          aria-controls='normal'
          aria-selected='true'
          @click="getNormalAnnouncement"
        ) {{ $t("ui.general") }}
      li.nav-item.flex-grow-1
        a#tab-special(
          data-toggle='tab'
          href='#special'
          role='tab'
          aria-controls='special'
          aria-selected='false'
          @click="getSpecialAnnouncement"
        ) {{ $t("ui.special") }}
      li.nav-item.flex-grow-1
        a#tab-personal(
          data-toggle='tab'
          href='#personal'
          role='tab'
          aria-controls='personal'
          aria-selected='false'
          @click="getPersonalMessage"
        ) {{ $t("ui.personal") }}
    .message-filter
      //- input.form-control.btn(type="date" v-model="dateFrom" @input="getData" required="required")
      //- .text {{ $t('ui.to') }}
      //- input.form-control.btn(type="date" v-model="dateTo" @input="getData" required="required")
      .input-group.mr-1
        date-picker.form-control.datepicker(v-model="dateFrom" :config="locale" @input="getData")
        .input-group-append
          span.input-group-text
            i.fas.fa-calendar-alt
      .d-flex.align-items-center.justify-content-center.pl-2.pr-2 {{ $t('ui.to') }}
      .input-group.mr-0.ml-1
        date-picker.form-control.datepicker(v-model="dateTo" :config="locale" @input="getData")
        .input-group-append
          span.input-group-text
            i.fas.fa-calendar-alt
  .pagepanel.tab-content
    template(v-if="loading")
      .message.dark
        .empty.text-center.mt-2.pt-4
          .loading-wrap.mb-3
            .loading
              .block
              .block
              .block
        p.no-message.text-center.mb-5 {{ $t("ui.loading") }}
    template(v-else)
      template(v-if="selected==='normal'")
        #normal.page-group.tab-pane.show(role='tabpanel' aria-labelledby='tab-normal' :class="{'active': selected === 'normal'}")
          .message(v-if="naList.list && naList.list.length == 0")
            .empty.text-center.mt-2.pt-4
              i.fas.fa-envelope
            p.no-message.text-center.mb-5 {{ $t("message.no_information_available") }}
          .message(v-else v-for="ann in naList.list")
            p.message-text.mb-0
              span.text-break {{ ann[`msg_${$store.getters.language}`] || ann.msg_en }}
            p.message-date.mb-0.grey {{ $dayjs(ann.an_date).format("MM/DD/YYYY hh:mm A") }}
      template(v-if="selected==='special'")
        #special.page-group.tab-pane.show(role='tabpanel' aria-labelledby='tab-special' :class="{'active': selected === 'special'}")
          .message(v-if="saList.list && saList.list.length == 0")
            .empty.text-center.mt-2.pt-4
              i.fas.fa-envelope
            p.no-message.text-center.mb-5 {{ $t("message.no_information_available") }}
          .message(v-else v-for="ann in saList.list")
            p.message-text.mb-2
              span.text-break {{ ann[`msg_${$store.getters.language}`] || ann.msg_en }}
            p.message-date.mb-0.grey {{ $dayjs(ann.an_date).format("MM/DD/YYYY hh:mm A") }}
      template(v-if="selected==='personal'")
        #personal.page-group.tab-pane.show(role='tabpanel' aria-labelledby='tab-personal' :class="{'active': selected === 'personal'}")
          .message(v-if="pmList.list && pmList.list.length == 0")
            .empty.text-center.mt-2.pt-4
              i.fas.fa-envelope
            p.no-message.text-center.mb-5 {{ $t("message.no_information_available") }}
          .message(v-else v-for="ann in pmList.list")
            p.message-text.mb-2
              span.text-break {{ ann[`msg_${$store.getters.language}`] || ann.msg_en }}
            p.message-date.mb-0.grey {{ $dayjs(ann.an_date).format("MM/DD/YYYY hh:mm A") }}
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import service from "@/library/_xhr-message";

export default {
  data() {
    return {
      loading: false,
      t: 1,
      dateFrom: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split("T")[0],
      dateTo: new Date().toISOString().split("T")[0],
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      naList: {},
      saList: {},
      pmList: {},
      selected: "normal",
      feedback: {
        success: false,
        status: errors.session.invalidSession
      }
    };
  },
  watch: {
    dateFrom(val) {
      if (val >= this.dateTo) {
        this.dateFrom = this.dateTo;
      }
    },
    dateTo(val) {
      if (val <= this.dateFrom) {
        this.dateTo = this.dateFrom;
      }
    }
  },
  mounted() {
    if (this.$route.query.redir === "p") {
      $("#tab-personal").click();
      this.getPersonalMessage();
    }
    this.getNormalAnnouncement();
  },
  methods: {
    getData() {
      if (this.selected === "normal") this.getNormalAnnouncement();
      if (this.selected === "special") this.getSpecialAnnouncement();
      if (this.selected === "personal") this.getPersonalMessage();
    },
    getNormalAnnouncement() {
      this.selected = "normal";
      this.naList = [];
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        datefrom: this.dateFrom,
        dateto: this.dateTo,
        an_type: 1
      };

      this.loading = true;

      service.getAnnoucement(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.$set(this.naList, "list", result.data);
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getSpecialAnnouncement() {
      this.selected = "special";
      this.saList = [];
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        datefrom: this.dateFrom,
        dateto: this.dateTo,
        an_type: 2
      };

      this.loading = true;

      service.getAnnoucement(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.$set(this.saList, "list", result.data);
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getPersonalMessage() {
      this.selected = "personal";
      this.pmList = [];
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        datefrom: this.dateFrom,
        dateto: this.dateTo
      };

      this.loading = true;

      service.getPersonalMessage(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.$set(this.pmList, "list", result.data);
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    }
  }
};
</script>
